import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Save } from "lucide-react";
import { adminApi } from "@/admin/adminApi";
import AdminLayout from "@/admin/AdminLayout";
import { toast } from "@/admin/Toast";

export default function ChangePasswordPage() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState(null);
  const [saving, setSaving] = useState(false);
  const nav = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    if (nw.length < 8) return setErr("New password must be at least 8 characters.");
    if (nw !== confirm) return setErr("New password and confirmation do not match.");
    setSaving(true);
    try {
      await adminApi.post("/change-password", { current_password: cur, new_password: nw });
      toast("success", "Password updated");
      nav("/admin");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Update failed");
    } finally {
      setSaving(false);
    }
  }

  return (
    <AdminLayout title="Change password">
      <form onSubmit={onSubmit} className="bg-white border border-mist-soft rounded-md p-6 max-w-md" data-testid="change-password-form">
        <label className="block mb-3">
          <span className="block text-[11px] uppercase tracking-[0.22em] text-mist-navy font-medium mb-1.5">Current password</span>
          <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required autoComplete="current-password" data-testid="cp-current" className="w-full h-10 px-3 bg-mist-off border border-mist-soft rounded-md text-sm focus:outline-none focus:border-mist-gold" />
        </label>
        <label className="block mb-3">
          <span className="block text-[11px] uppercase tracking-[0.22em] text-mist-navy font-medium mb-1.5">New password</span>
          <input type="password" value={nw} onChange={(e) => setNw(e.target.value)} required minLength={8} autoComplete="new-password" data-testid="cp-new" className="w-full h-10 px-3 bg-mist-off border border-mist-soft rounded-md text-sm focus:outline-none focus:border-mist-gold" />
        </label>
        <label className="block mb-3">
          <span className="block text-[11px] uppercase tracking-[0.22em] text-mist-navy font-medium mb-1.5">Confirm new password</span>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} autoComplete="new-password" data-testid="cp-confirm" className="w-full h-10 px-3 bg-mist-off border border-mist-soft rounded-md text-sm focus:outline-none focus:border-mist-gold" />
        </label>
        {err && <div className="mt-2 text-xs text-red-600" role="alert">{err}</div>}
        <button type="submit" disabled={saving} data-testid="cp-save" className="mt-4 inline-flex items-center gap-2 bg-mist-navy text-white px-6 h-10 text-[11px] uppercase tracking-[0.22em] font-semibold rounded-full hover:bg-mist-navy/90 disabled:opacity-60">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
          Save
        </button>
      </form>
    </AdminLayout>
  );
}
